import React from "react";
import { connect } from "react-redux";
import style from "../../assets/css/modules/health-support/cancerdiagnosticservices.css";
import Content from "../../content/Content";
import contentify from "../../content/Contentify";
import Store from "../../content/Store";
import HomeCard from "../home/HomeCard";
import GenericHero from "../shared/GenericHero";
import CancerSupportItem from "./CancerSupportItem";
import HelpSectionCancer from "../shared/HelpSectionCancer";
import { Paths } from "../../constants/UrlConstants";

export const mapStateToCancerDiagnosticServices = (state) => {
  const currentPolicy = state.policyReducer.selectedPolicy;
  const isInternationalOrSaga =
    currentPolicy && (currentPolicy.IsSaga || currentPolicy.IsInternational);
  const isLapsed = currentPolicy && currentPolicy.IsLapsed;
  const isChildOnly = currentPolicy?.IsChildOnlyPolicy;

  return {
    isLapsed,
    isInternationalOrSaga,
    layout: state.layoutReducer && state.layoutReducer.layout,
    isSMEModular: currentPolicy && currentPolicy.IsSMEModular,
    isLargeCorporate: currentPolicy && currentPolicy.IsLargeCorporate,
    isEDCA: currentPolicy && currentPolicy.IsEDCA,
    isChildOnly: isChildOnly
  };
};

//let helpSet = [Store.CancerDiagnosticServices.CancerFaq];
export const CancerDiagnosticServices = function (props) {
  //const content = props.content;
  return (
    <React.Fragment>
<div className={`home ${style.CancerDiagnosticServices}`}>
          <GenericHero
            HeroBG={Store.CancerDiagnosticServices.HeroContent.Check4CancerBannerSrc}
            HeroBGMobile={
              Store.CancerDiagnosticServices.HeroContent.Check4CancerBannerSrcMobile
            }
            Heading={Store.CancerDiagnosticServices.HeroContent.Heading}
            DarkOverlay={false}
            ExtraClasses={style.removeBoxPaddingAtBottom}
          >
            <h2 className={style.header} data-hero-header>
              {}
            </h2>
            <p data-hero-body>{Store.CancerDiagnosticServices.HeroContent.Description}</p>
                {
                  Store.CancerDiagnosticServices.healthSupportItems.health.map((item, key) => (
                    <CancerSupportItem
                      key={key}
                      IconSrc={item.IconSrc}
                      Heading={item.Heading}
                      Desc={item.Desc}
                      Links={item.Links}
                    />
                  ))}
                  <p></p>
                <div className={style.helpSection}>
                  <HelpSectionCancer
                    HeadingLinkText={Store.GeneralPages.HelpHeadingLinkText}
                    HeadingLinkTo={Paths.Help}
                    HelpSet={Store.CancerDiagnosticServices.HelpSetCancer.helpSet}
                  />
                </div>
          </GenericHero>
          </div>
          <div className="container">
        <div className="row">
        {!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly) ? (
          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly) ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.GPAppointment.IconSrc,
                Store.CancerDiagnosticServices.Cards.GPAppointment.Heading,
                Store.CancerDiagnosticServices.Cards.GPAppointment.Description,
                Store.CancerDiagnosticServices.Cards.GPAppointment.LinkText,
                Store.CancerDiagnosticServices.Cards.GPAppointment.LinkTo,
              ]}

            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  Healthsupport1="HealthSupport"
                />
              )}
            </Content>
          </div>
        ) : null}
          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly)  ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.HealthSupport.IconSrc,
                Store.CancerDiagnosticServices.Cards.HealthSupport.Heading,
                Store.CancerDiagnosticServices.Cards.HealthSupport.Description,
                Store.CancerDiagnosticServices.Cards.HealthSupport.LinkText,
                Store.CancerDiagnosticServices.Cards.HealthSupport.LinkTo,
              ]}
            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  Healthsupport1="HealthSupport"
                />
              )}
            </Content>
          </div>

          <div
            className={
              (!(props.isInternationalOrSaga || props.isLapsed || props.isChildOnly) ? "col-lg-4" : "col-lg-6")
            }
            data-explore-my-cover-home-card
          >
            <Content
              names={[
                Store.CancerDiagnosticServices.Cards.CancerSupport.IconSrc,
                Store.CancerDiagnosticServices.Cards.CancerSupport.Heading,
                Store.CancerDiagnosticServices.Cards.CancerSupport.Description,
                Store.CancerDiagnosticServices.Cards.CancerSupport.LinkText,
                Store.CancerDiagnosticServices.Cards.CancerSupport.LinkTo,
              ]}
            >
              {(iconSrc, heading, description, linktext, linkto) => (
                <HomeCard
                  IconSrc={iconSrc}
                  Heading={heading}
                  Description={description}
                  LinkText={linktext}
                  LinkTo={linkto}
                  ExternalLinkTo={true}
                  Healthsupport1="HealthSupport"
                  externalNav="externalNav"
                />
              )}
            </Content>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

CancerDiagnosticServices.content = Store.CancerDiagnosticServices;

export default connect(mapStateToCancerDiagnosticServices)(contentify(CancerDiagnosticServices));
